<ng-container *ngIf="loadingData">
    <div class="skeleton skeleton-table-row" style="height: 50px;"></div>
    <div class="skeleton skeleton-table-row" *ngFor="let i of [0,0,0,0,0,0,0,0,0,0,0]"></div>
</ng-container>

<ng-container *ngIf="!loadingData">

    <dx-data-grid
        #changePriorTrackerGrid 
        id="changePriorTrackerGrid"
        class="grid-with-header"
        [dataSource]="changePriorTrackerList"
        [allowColumnResizing]="true" 
        [columnResizingMode]="'widget'" 
        [hoverStateEnabled]="true"
        [rowAlternationEnabled]="true" 
        [columnAutoWidth]="true" 
        [allowColumnReordering]="true"
        noDataText="There is no activity registered in Change From Prior section"
        (onExporting)="onExporting($event)"
    >
        <!-- <dxo-toolbar>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button
                        *ngIf="showPhAdmin"
                        icon="refresh"
                        hint="Refresh"
                        (click)="fetchPublishHistoryData()"
                    ></dx-button>
                    <dx-button
                        *ngIf="showPhAdmin && publishHistoryList.length"
                        icon="exportxlsx"
                        hint="Excel Export"
                        (click)="onExporting($event)"
                    ></dx-button>
                </div>
            </dxi-item>
        </dxo-toolbar> -->

        <dxo-paging [pageSize]="20" [pageIndex]="0"> </dxo-paging>
        <dxo-pager
            [visible]="changePriorTrackerList.length>0"
            [allowedPageSizes]="[20, 30, 50]"
            [showPageSizeSelector]="true"
            [showInfo]="true"
            [showNavigationButtons]="true"
        ></dxo-pager>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-export [enabled]="true" ></dxo-export>
        
        <ng-container *ngFor="let column of displayColumns">
            <dxi-column 
                [dataField]="column.dataField" 
                [dataType]="column.dataType"
                [caption]="column.caption" 
                [format]="column.format"
                [cellTemplate]="column.cellTemplate"
                >
            </dxi-column>
        </ng-container>

        <div *dxTemplate="let d of 'numberTemplate'">
            <div>{{d.value == null? 0: d.value}}</div>
        </div>

    </dx-data-grid>

</ng-container>

<app-load-panel *ngIf="showLoadPanel" [option]="loadPanelOption"></app-load-panel>